import { Box, Flex } from 'components/elements'
import {
  ShimmerCss,
  Tags2Css,
  TitleCss,
  DescriptionCss,
  IconButtonCss,
} from './styles'
import { TextShimmer } from './text'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'

export const DiscrepancyListShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }} />
        <Box css={{ ...ShimmerCss, ...DescriptionCss }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }} />
        <Box css={{ ...ShimmerCss, ...DescriptionCss }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box
          css={{ ...ShimmerCss, ...Tags2Css, width: 175, mr: '$space$5' }}
        ></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box
          css={{ ...ShimmerCss, ...Tags2Css, width: 175, mr: '$space$5' }}
        ></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
